import React, { useEffect } from 'react';
import {
  ImageModal as ModalContainer,
  ModalImage,
  ModalCloseButton
} from '../styles/EventSidebar.styles';

const ImageModal = ({ selectedImage, onClose }) => {
  // Prevenire scroll del body quando modal è aperto
  useEffect(() => {
    if (selectedImage) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [selectedImage]);

  // Gestione tasti per il modal
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && selectedImage) {
        onClose();
      }
    };
    
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [selectedImage, onClose]);

  if (!selectedImage) return null;

  return (
    <ModalContainer onClick={onClose}>
      <ModalCloseButton onClick={onClose}>
        ×
      </ModalCloseButton>
      <ModalImage 
        src={selectedImage.url} 
        alt={selectedImage.alternativeText || 'Immagine evento'}
        onClick={(e) => e.stopPropagation()}
      />
    </ModalContainer>
  );
};

export default ImageModal;
